// Configuration for Recommendations page forms

// Dataset categories (labels must match backend)
export const DATASET_CATEGORIES = [
  { value: "screening_factors", label: "Factors Related to Screening" },
  { value: "air_pollution", label: "Air Pollution" },
];

// Variables for forecasting (from Excel parsing step)
export const VARIABLES_BY_CATEGORY = {
  screening_factors: [
    { value: "prop_on_financial_aid", label: "Prop on Financial Aid" },
    { value: "screening_coverage", label: "Screening Coverage" },
    { value: "70_74_year_olds", label: "70-74-Year Olds" },
    { value: "deprivation_index", label: "Deprivation Index" },
    { value: "screening_response_rate", label: "Screening Response Rate" },
    { value: "ar_tu_be_at_home", label: "AR/TU/BE at Home" },
    { value: "sec_education", label: "Sec Education" },
    { value: "prop_disabled", label: "Prop Disabled" },
    { value: "local_service_centres", label: "Local Service Centres" },
    { value: "55_59_year_olds", label: "55-59-Year Olds" },
    { value: "du_at_home", label: "DU at Home" },
    { value: "65_69_year_olds", label: "65-69-Year Olds" },
    { value: "population_size", label: "Population Size" },
    { value: "prop_males", label: "Prop Males" },
    { value: "prop_children", label: "Prop Children" },
    { value: "prop_retired", label: "Prop Retired" },
    { value: "prop_with_recent_gp_visit", label: "Prop with Recent GP Visit" },
    { value: "fr_at_home", label: "FR at Home" },
    { value: "non_du_at_home", label: "Non-DU at Home" },
    { value: "prop_self_employed", label: "Prop Self-Employed" },
    { value: "ge_nl_at_home", label: "GE/NL at Home" },
    { value: "60_64_year_olds", label: "60-64-Year Olds" },
    {
      value: "prop_not_in_social_security",
      label: "Prop Not in Social Security",
    },
    { value: "50_54_year_olds", label: "50-54-Year Olds" },
    { value: "average_income", label: "Average Income" },
    { value: "prop_chronically_diseased", label: "Prop Chronically Diseased" },
    { value: "ru_pl_ro_at_home", label: "RU/PL/RO at Home" },
    { value: "patients_per_gp_practice", label: "Patients per GP Practice" },
    { value: "other_language_at_home", label: "Other Language at Home" },
    { value: "prim_education", label: "Prim Education" },
    { value: "median_income", label: "Median Income" },
    { value: "population_density", label: "Population Density" },
    {
      value: "prop_with_global_med_record",
      label: "Prop with Global Med Record",
    },
    { value: "prop_wage_earners", label: "Prop Wage-Earners" },
    { value: "gini_index", label: "Gini Index" },
    { value: "sp_pg_at_home", label: "SP/PG at Home" },
    { value: "tert_education", label: "Tert Education" },
  ],
  air_pollution: [
    { value: "population", label: "Population" },
    { value: "premature_deaths", label: "Premature Deaths" },
    { value: "years_of_life_lost", label: "Years Of Life Lost" },
    { value: "populated_area", label: "Populated Area [km2]" },
    {
      value: "air_pollutions_avg",
      label: "Air Pollution Average [ug/m3]",
    },
    { value: "health_risk", label: "Health Risk Scenario" },
    {
      value: "air_pollution_weighted_avg",
      label: "Air Pollution Population Weighted Average [ug/m3]",
    },
  ],
};

// Variables for correlation analysis
export const CORRELATION_VARIABLES_BY_CATEGORY = {
  screening_factors: [
    { value: "Screening Coverage", label: "Screening Coverage" },
    { value: "Screening Response Rate", label: "Screening Response Rate" },
    { value: "Non-DU at Home", label: "Non-DU at Home" },
    { value: "DU at Home", label: "DU at Home" },
    { value: "FR at Home", label: "FR at Home" },
    { value: "GE/EN at Home", label: "GE/EN at Home" },
    { value: "RU/PL/RO at Home", label: "RU/PL/RO at Home" },
    { value: "SP/PG at Home", label: "SP/PG at Home" },
    { value: "AR/TU/BE at Home", label: "AR/TU/BE at Home" },
    { value: "Other Language at Home", label: "Other Language at Home" },
    { value: "50-54-Year Olds", label: "50-54-Year Olds" },
    { value: "55-59-Year Olds", label: "55-59-Year Olds" },
    { value: "60-64-Year Olds", label: "60-64-Year Olds" },
    { value: "65-69-Year Olds", label: "65-69-Year Olds" },
    { value: "70-74-Year Olds", label: "70-74-Year Olds" },
    { value: "Prop Males", label: "Prop Males" },
    { value: "Prop Wage-Earners", label: "Prop Wage-Earners" },
    { value: "Prop Self-Employed", label: "Prop Self-Employed" },
    { value: "Prop Jobseekers", label: "Prop Jobseekers" },
    { value: "Prop on Financial Aid", label: "Prop on Financial Aid" },
    { value: "Prop Retired", label: "Prop Retired" },
    { value: "Prop Children", label: "Prop Children" },
    { value: "Prop Not in Social Security", label: "Prop Not in Social Security" },
    { value: "Population Density", label: "Population Density" },
    { value: "Population Size", label: "Population Size" },
    { value: "Prim Education", label: "Prim Education" },
    { value: "Sec Education", label: "Sec Education" },
    { value: "Tert Education", label: "Tert Education" },
    { value: "Education Unknown", label: "Education Unknown" },
    { value: "Average Income", label: "Average Income" },
    { value: "Median Income", label: "Median Income" },
    { value: "Deprivation Index", label: "Deprivation Index" },
    { value: "Prop Chronically Diseased", label: "Prop Chronically Diseased" },
    { value: "Prop with Global Med Record", label: "Prop with Global Med Record" },
    { value: "Prop with Recent GP Visit", label: "Prop with Recent GP Visit" },
    { value: "Prop Disabled", label: "Prop Disabled" },
    { value: "Local Service Centres", label: "Local Service Centres" },
    { value: "Patients per GP Practice", label: "Patients per GP Practice" },
  ],
  air_pollution: [
    { value: "Degree Of Urbanisation", label: "Degree Of Urbanisation" },
    { value: "Year", label: "Year" },
    { value: "Air Pollutant", label: "Air Pollutant" },
    { value: "Health Risk Scenario", label: "Health Risk Scenario" },
    { value: "Population", label: "Population" },
    { value: "Populated Area [km2]", label: "Populated Area [km2]" },
    { value: "Air Pollution Average [ug/m3]", label: "Air Pollution Average [ug/m3]" },
    { value: "Air Pollution Population Weighted Average [ug/m3]", label: "Air Pollution Population Weighted Average [ug/m3]" },
    { value: "Premature Deaths", label: "Premature Deaths" },
    { value: "Premature Deaths - lower CI", label: "Premature Deaths - lower CI" },
    { value: "Premature Deaths - upper CI", label: "Premature Deaths - upper CI" },
    { value: "Years Of Life Lost", label: "Years Of Life Lost" },
    { value: "Years Of Life Lost - lower CI", label: "Years Of Life Lost - lower CI" },
    { value: "Years Of Life Lost - upper CI", label: "Years Of Life Lost - upper CI" },
  ],
};

// European regions by NUTS level
export const REGIONS_BY_NUTS = {
  1: [
    // Belgium
    { value: "BE1", label: "Brussels" },
    { value: "BE2", label: "Flanders" },
    { value: "BE3", label: "Wallonia" },
    // Netherlands
    { value: "NL1", label: "North Netherlands" },
    { value: "NL2", label: "East Netherlands" },
    { value: "NL3", label: "West Netherlands" },
    { value: "NL4", label: "South Netherlands" },
    // France
    { value: "FR1", label: "Île-de-France" },
    { value: "FRB", label: "Centre-Val de Loire" },
    { value: "FRC", label: "Bourgogne-Franche-Comté" },
    { value: "FRD", label: "Normandie" },
    { value: "FRE", label: "Hauts-de-France" },
    { value: "FRF", label: "Grand Est" },
    { value: "FRG", label: "Pays de la Loire" },
    { value: "FRH", label: "Bretagne" },
    { value: "FRI", label: "Nouvelle-Aquitaine" },
    { value: "FRJ", label: "Occitanie" },
    { value: "FRK", label: "Auvergne-Rhône-Alpes" },
    { value: "FRL", label: "Provence-Alpes-Côte d'Azur" },
    { value: "FRM", label: "Corse" },
    // Germany
    { value: "DE1", label: "Baden-Württemberg" },
    { value: "DE2", label: "Bavaria" },
    { value: "DE3", label: "Berlin" },
    { value: "DE4", label: "Brandenburg" },
    { value: "DE5", label: "Bremen" },
    { value: "DE6", label: "Hamburg" },
    { value: "DE7", label: "Hesse" },
    { value: "DE8", label: "Mecklenburg-Vorpommern" },
    { value: "DE9", label: "Lower Saxony" },
    { value: "DEA", label: "North Rhine-Westphalia" },
    { value: "DEB", label: "Rhineland-Palatinate" },
    { value: "DEC", label: "Saarland" },
    { value: "DED", label: "Saxony" },
    { value: "DEE", label: "Saxony-Anhalt" },
    { value: "DEF", label: "Schleswig-Holstein" },
    { value: "DEG", label: "Thuringia" },
  ],
  2: [
    // Belgium NUTS2
    { value: "BE10", label: "Brussels Capital Region" },
    { value: "BE21", label: "Antwerp" },
    { value: "BE22", label: "Limburg (BE)" },
    { value: "BE23", label: "East Flanders" },
    { value: "BE24", label: "Flemish Brabant" },
    { value: "BE25", label: "West Flanders" },
    { value: "BE31", label: "Walloon Brabant" },
    { value: "BE32", label: "Hainaut" },
    { value: "BE33", label: "Liège" },
    { value: "BE34", label: "Luxembourg (BE)" },
    { value: "BE35", label: "Namur" },
    // Netherlands NUTS2
    { value: "NL11", label: "Groningen" },
    { value: "NL12", label: "Friesland" },
    { value: "NL13", label: "Drenthe" },
    { value: "NL21", label: "Overijssel" },
    { value: "NL22", label: "Gelderland" },
    { value: "NL23", label: "Flevoland" },
    { value: "NL31", label: "Utrecht" },
    { value: "NL32", label: "North Holland" },
    { value: "NL33", label: "South Holland" },
    { value: "NL34", label: "Zeeland" },
    { value: "NL41", label: "North Brabant" },
    { value: "NL42", label: "Limburg (NL)" },
    // France NUTS2 (selected regions)
    { value: "FR10", label: "Île-de-France" },
    { value: "FRB0", label: "Centre-Val de Loire" },
    { value: "FRC1", label: "Bourgogne" },
    { value: "FRC2", label: "Franche-Comté" },
    { value: "FRD1", label: "Basse-Normandie" },
    { value: "FRD2", label: "Haute-Normandie" },
    { value: "FRE1", label: "Nord-Pas-de-Calais" },
    { value: "FRE2", label: "Picardie" },
    { value: "FRF1", label: "Alsace" },
    { value: "FRF2", label: "Champagne-Ardenne" },
    { value: "FRF3", label: "Lorraine" },
    { value: "FRG0", label: "Pays de la Loire" },
    { value: "FRH0", label: "Bretagne" },
    { value: "FRI1", label: "Aquitaine" },
    { value: "FRI2", label: "Limousin" },
    { value: "FRI3", label: "Poitou-Charentes" },
    { value: "FRJ1", label: "Languedoc-Roussillon" },
    { value: "FRJ2", label: "Midi-Pyrénées" },
    { value: "FRK1", label: "Auvergne" },
    { value: "FRK2", label: "Rhône-Alpes" },
    { value: "FRL0", label: "Provence-Alpes-Côte d'Azur" },
    { value: "FRM0", label: "Corse" },
    // Germany NUTS2 (selected regions)
    { value: "DE11", label: "Stuttgart" },
    { value: "DE12", label: "Karlsruhe" },
    { value: "DE13", label: "Freiburg" },
    { value: "DE14", label: "Tübingen" },
    { value: "DE21", label: "Upper Bavaria" },
    { value: "DE22", label: "Lower Bavaria" },
    { value: "DE23", label: "Upper Palatinate" },
    { value: "DE24", label: "Upper Franconia" },
    { value: "DE25", label: "Middle Franconia" },
    { value: "DE26", label: "Lower Franconia" },
    { value: "DE27", label: "Swabia" },
    { value: "DE30", label: "Berlin" },
    { value: "DE40", label: "Brandenburg" },
    { value: "DE50", label: "Bremen" },
    { value: "DE60", label: "Hamburg" },
    { value: "DE71", label: "Darmstadt" },
    { value: "DE72", label: "Gießen" },
    { value: "DE73", label: "Kassel" },
    { value: "DE80", label: "Mecklenburg-Vorpommern" },
    { value: "DE91", label: "Braunschweig" },
    { value: "DE92", label: "Hannover" },
    { value: "DE93", label: "Lüneburg" },
    { value: "DE94", label: "Weser-Ems" },
    { value: "DEA1", label: "Düsseldorf" },
    { value: "DEA2", label: "Cologne" },
    { value: "DEA3", label: "Münster" },
    { value: "DEA4", label: "Detmold" },
    { value: "DEA5", label: "Arnsberg" },
    { value: "DEB1", label: "Koblenz" },
    { value: "DEB2", label: "Trier" },
    { value: "DEB3", label: "Rheinhessen-Pfalz" },
    { value: "DEC0", label: "Saarland" },
    { value: "DED2", label: "Dresden" },
    { value: "DED4", label: "Chemnitz" },
    { value: "DED5", label: "Leipzig" },
    { value: "DEE0", label: "Saxony-Anhalt" },
    { value: "DEF0", label: "Schleswig-Holstein" },
    { value: "DEG0", label: "Thuringia" },
  ],
  3: [
    // Belgium NUTS3 (selected)
    { value: "BE100", label: "Brussels Capital Region" },
    { value: "BE211", label: "Arrondissement of Antwerp" },
    { value: "BE212", label: "Arrondissement of Mechelen" },
    { value: "BE213", label: "Arrondissement of Turnhout" },
    { value: "BE221", label: "Arrondissement of Hasselt" },
    { value: "BE222", label: "Arrondissement of Maaseik" },
    { value: "BE223", label: "Arrondissement of Tongeren" },
    { value: "BE231", label: "Arrondissement of Aalst" },
    { value: "BE232", label: "Arrondissement of Dendermonde" },
    { value: "BE233", label: "Arrondissement of Eeklo" },
    { value: "BE234", label: "Arrondissement of Ghent" },
    { value: "BE235", label: "Arrondissement of Oudenaarde" },
    { value: "BE236", label: "Arrondissement of Sint-Niklaas" },
    { value: "BE241", label: "Arrondissement of Halle-Vilvoorde" },
    { value: "BE242", label: "Arrondissement of Leuven" },
    { value: "BE251", label: "Arrondissement of Brugge" },
    { value: "BE252", label: "Arrondissement of Diksmuide" },
    { value: "BE253", label: "Arrondissement of Ieper" },
    { value: "BE254", label: "Arrondissement of Kortrijk" },
    { value: "BE255", label: "Arrondissement of Oostende" },
    { value: "BE256", label: "Arrondissement of Roeselare" },
    { value: "BE257", label: "Arrondissement of Tielt" },
    { value: "BE258", label: "Arrondissement of Veurne" },
    { value: "BE310", label: "Arrondissement of Nivelles" },
    { value: "BE321", label: "Arrondissement of Ath" },
    { value: "BE322", label: "Arrondissement of Charleroi" },
    { value: "BE323", label: "Arrondissement of Mons" },
    { value: "BE324", label: "Arrondissement of Mouscron" },
    { value: "BE325", label: "Arrondissement of Soignies" },
    { value: "BE326", label: "Arrondissement of Thuin" },
    { value: "BE327", label: "Arrondissement of Tournai" },
    { value: "BE331", label: "Arrondissement of Huy" },
    { value: "BE332", label: "Arrondissement of Liège" },
    { value: "BE334", label: "Arrondissement of Verviers" },
    { value: "BE335", label: "Arrondissement of Waremme" },
    { value: "BE336", label: "Arrondissement of Bastogne" },
    { value: "BE341", label: "Arrondissement of Arlon" },
    { value: "BE342", label: "Arrondissement of Marche-en-Famenne" },
    { value: "BE343", label: "Arrondissement of Neufchâteau" },
    { value: "BE344", label: "Arrondissement of Virton" },
    { value: "BE351", label: "Arrondissement of Dinant" },
    { value: "BE352", label: "Arrondissement of Namur" },
    { value: "BE353", label: "Arrondissement of Philippeville" },
    // Netherlands NUTS3 (selected major cities)
    { value: "NL111", label: "East Groningen" },
    { value: "NL113", label: "Other Groningen" },
    { value: "NL124", label: "Southeast Friesland" },
    { value: "NL131", label: "North Drenthe" },
    { value: "NL213", label: "Twente" },
    { value: "NL221", label: "Veluwe" },
    { value: "NL224", label: "Southwest Gelderland" },
    { value: "NL230", label: "Flevoland" },
    { value: "NL310", label: "Utrecht" },
    { value: "NL321", label: "Kop van Noord-Holland" },
    { value: "NL323", label: "IJmond" },
    { value: "NL327", label: "Het Gooi en Vechtstreek" },
    { value: "NL328", label: "Agglomeration Amsterdam" },
    { value: "NL329", label: "Zaanstreek" },
    { value: "NL332", label: "Agglomeration The Hague" },
    { value: "NL333", label: "Delft and West" },
    { value: "NL337", label: "Agglomeration Rotterdam" },
    { value: "NL33A", label: "Southeast South Holland" },
    { value: "NL341", label: "Zeeuwsch-Vlaanderen" },
    { value: "NL342", label: "Other Zeeland" },
    { value: "NL411", label: "West North Brabant" },
    { value: "NL412", label: "Middle North Brabant" },
    { value: "NL413", label: "Northeast North Brabant" },
    { value: "NL414", label: "Southeast North Brabant" },
    { value: "NL421", label: "North Limburg" },
    { value: "NL422", label: "Middle Limburg" },
    { value: "NL423", label: "South Limburg" },
  ],
};

// Helper function to get NUTS label
export const nutsLabel = (n) => (n === 1 ? "NUTS1" : n === 2 ? "NUTS2" : "NUTS3");

// Current year constant
export const CURRENT_YEAR = new Date().getFullYear();
